import { Navigate, useLocation } from "react-router-dom";
import { useAuth, hasAccess } from "../context/AuthContext";

export default function ProtectedRoute({ children, appId, write = false, superAdminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center text-envicom-muted font-mono text-sm">
        Initialising session…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (superAdminOnly && user.role !== "super_admin") {
    return <Navigate to="/" replace />;
  }
  if (appId && !hasAccess(user, appId, write)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
